// Internal, non-serializable marker. It can only suppress a legacy nudge;
// it never grants permission or marks a commit as completed.
const LOCAL_DELIVERY = Symbol('apolo-local-delivery');
export function scopeDeliveryMessages(messages, taskText) {
  const text = String(taskText || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const localOnly = /\b(?:nao|sem|do not|don't|no)\s+(?:(?:execute|executar|faca|fazer|realize|realizar|run|create)\s+)?(?:git\b|commits?\b|prs?\b|pull requests?\b)/i.test(text);
  if (!localOnly || !messages.length) return messages;
  const first = { ...messages[0] };
  Object.defineProperty(first, LOCAL_DELIVERY, { value: true });
  return [first, ...messages.slice(1)];
}
export function permitsCommitNudge(messages) {
  return !messages?.some((message) => message?.[LOCAL_DELIVERY] === true);
}
